module.exports = __webpack_public_path__ + "img/_PWK2739_-PSedit_.c3339e66.jpeg";